module.exports = __webpack_public_path__ + "static/media/9.c2856adc.mp3";